import dayjs from "dayjs";
import * as S from "./ArticleItem.style";
import { Link } from "react-router-dom";

interface ArticleItemProps {
  data?: any;
}

export const ArticleItem = ({ data }: ArticleItemProps) => {
  return (
    <S.ArticleItem>
      <Link to={`/setting/notice/detail/${data.id}`}>
        <S.ArticleTit $readed={data.nvhId ? true : false}>
          <span>
            {data.type === "event" ? "이벤트" : "공지사항"}{" "}
            <span>{data.nvhId ? "읽음" : "읽지않음"}</span>
          </span>
          <div>{data.title}</div>
        </S.ArticleTit>

        <S.ArticleDate>
          {data.createdAt
            ? dayjs(data.createdAt).format("YYYY-MM-DD HH:mm:ss")
            : ""}
        </S.ArticleDate>
      </Link>
    </S.ArticleItem>
  );
};
